// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"72972a97","247":"6eb01c91","422":"e77cee26","627":"e69adaa0","834":"156c854a","867":"75983651","923":"88961295","938":"36659d9b"}[chunkId] + ".chunk.js";
};